import { isIos } from "./util";

/**
 * 提供原生方法唤起统一方法接口
 * @param iosMethod: ios原生方法
 * @param androidMethod: android原生方法
 * @param param: 传递参数(一般是字符串...为什么原生不传数字orz?????)
 */

const methodInvoke = (
  iosMethod: string,
  androidMethod: string,
  param: any,
  callback?: () => void
) => {
  if (isIos() === 1) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers[iosMethod]
    ) {
      window.webkit.messageHandlers[iosMethod].postMessage(param);
    } else {
      callback && callback();
    }
  } else if (isIos() === 2) {
    if (window.android && window.android[androidMethod]) {
      window.android[androidMethod](param);
    } else {
      callback && callback();
    }
  }
};

/**
 * 万能胶修复
 * @param isRepair: 是否修复：1:是 0:不是
 */
let repairWnj = (isRepair: number | string) =>
  methodInvoke("RepairBurnNoteModel", "callRepairLongPaper", isRepair);

/**
 * 试看模式不显示评论模块
 * @param isShow: 是否试看：1:不是 0:是
 */
let onPreviewWithoutShowComments = (isShow: number | string) =>
  methodInvoke("NoteArticleCanShowModel", "callIsLongPaperCanShow", isShow);

/**
 * 是否允许分享
 * @param isShare: 是否分享：1:不是 0:是
 */
let limitShare = (isShare: number | string) =>
  methodInvoke("LimitShareModel", "callLimitShare", isShare);

/**
 * 调用登陆
 * @param isLogin: 是否登陆：1:不是 0:是
 */
let callLogin = (isLogin: number | string) =>
  methodInvoke("LoginModel", "callLogin", isLogin);

/**
 * 调用音频播放
 * @param 音频播放
 */
let audioPlay = (status: number | string) =>
  methodInvoke("AudioPlayAction", "audioPlayAction", status);

/**
 * 调用分享
 * @param 分享
 */
let callShareObject = (jsonString: number | string) =>
  methodInvoke("ShareModel", "callShareObject", jsonString);

/**
 * 调用练笔
 * @param 练笔
 */
let WritingDetailAction = (id: number) =>
  methodInvoke("WritingDetailAction", "writingDetailAction", id);

/**
 * 调用练笔分享
 * @param 练笔
 */
let WritingShareActionBox = (data: any) =>
  methodInvoke("WritingShareAction", "practiceShare", data);

/**
 * 调用收藏
 * @param 收藏
 */
let CallCollectBox = (data: any) =>
  methodInvoke("WritingCollectAction", "writingCollectAction", data);

/**
 * 返回上一页
 * @param 返回
 */
let callAppBack = (type: any) =>
  methodInvoke("NavBackAction", "navBackAction", type);

let routerToPage = (href: any, callback: any) => {
  methodInvoke('routerAppUrl', 'routerAppUrl', href, callback);
};

let routerToNativePage = (href: any, callback: any) => {
  let url = `zuowenzhitiao://main/webView?url=${encodeURIComponent(href)}`;
  methodInvoke('routerAppUrl', 'routerAppUrl', url, callback);
};
let callShowTopNavigation = ({ close = 0, refresh = 0, share = 0}:any) => {
  // close 是否隐藏顶部栏的关闭按钮 0 隐藏  1显示
  // refresh 是否隐藏顶部栏的刷新按钮 0 隐藏 1 显示
  // share 是否隐藏顶部栏分享按钮 0 隐藏 1 显示
  methodInvoke('callShowTopNavigation', 'callShowTopNavigation', JSON.stringify({ close, refresh, share}));
}
/**
 * 复制
 * @param copyStr: 复制内容
 */
let copyAction = (copyStr: string) => {
  methodInvoke('copyAction', 'copyAction', copyStr)
}

export default {
  repairWnj,
  onPreviewWithoutShowComments,
  limitShare,
  callLogin,
  audioPlay,
  callShareObject,
  WritingDetailAction,
  WritingShareActionBox,
  CallCollectBox,
  callAppBack,
  routerToPage,
  routerToNativePage,
  callShowTopNavigation,
  copyAction
};
